import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { comics } from "@/mocks/comics";

export default function CategorySection() {
  return (
    <section className="bg-background-50 py-12 md:py-16" aria-labelledby="category-heading">
      <div className="container-x">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <h2 id="category-heading" className="font-display text-2xl font-black text-foreground-900 md:text-3xl">
              漫画网漫画分类
            </h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">六大分类速查，总有一个戳中你</p>
          </div>
          <Link to="/category/all" className="flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => {
            const count = comics.filter((x) => x.categoryId === c.id).length;
            return (
              <Link
                key={c.id}
                to={`/category/${c.id}`}
                className="group flex flex-col items-center rounded-lg border border-background-200/70 bg-background-50 p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:bg-primary-50"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-16 md:w-16">
                  <i className={`${c.icon} text-2xl md:text-3xl`}></i>
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-900">{c.name}漫画</h3>
                <p className="mt-1 text-xs text-foreground-500">{count} 部收录</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}